import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow w-full rounded-2xl px-8 py-3 justify-between items-start h-full" }
const _hoisted_2 = { class: "flex flex-row lg:justify-end md:justify-end justify-around space-x-5 items-center" }
const _hoisted_3 = { class: "pt-2 relative" }
const _hoisted_4 = {
  key: 0,
  class: "pt-2 relative"
}
const _hoisted_5 = { class: "flex justify-center items-center pt-1 relative" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-5 w-5\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\"></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\"></line></svg><span class=\"ml-2 text-sm hidden lg:flex md:flex\">Reject</span>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  class: "flex lg:truncate bg-primary text-white text-sm p-2 rounded-full border-2 border-white hover:bg-primary-hover"
}
const _hoisted_11 = { class: "flex items-center space-x-3" }
const _hoisted_12 = {
  key: 2,
  class: "pt-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "truncate text-white text-sm font-bold px-4 py-2 bg-primary rounded-full" }, "Hired", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "space-y-2 lg:mt-0 mt-6" }
const _hoisted_16 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_17 = { class: "flex justify-center items-center rounded-full bg-primary text-white text-4xl w-20 h-20 p-4" }
const _hoisted_18 = { class: "flex flex-col lg:justify-start p-4 space-y-1 w-full items-center lg:items-start lg:mt-0 mt-2" }
const _hoisted_19 = { class: "block text-2xl font-bold" }
const _hoisted_20 = { class: "block text-sm text-gray-400" }
const _hoisted_21 = {
  key: 0,
  class: "block text-sm text-gray-400"
}
const _hoisted_22 = {
  key: 1,
  class: "block text-sm text-gray-400"
}
const _hoisted_23 = {
  key: 2,
  class: "block text-sm text-gray-400"
}
const _hoisted_24 = {
  key: 3,
  class: "block text-sm text-gray-400"
}
const _hoisted_25 = { class: "space-y-3 pt-3" }
const _hoisted_26 = { class: "sm:flex sm:justify-center items-center sm:w-max select-none" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "animate__animated animate__fadeIn"
}
const _hoisted_31 = { class: "space-y-3 p-3 w-full" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "block text-2xl font-bold" }, "Candidate Profile", -1)
const _hoisted_33 = {
  key: 0,
  class: "block text-base font-bold"
}
const _hoisted_34 = { class: "text-xs opacity-30" }
const _hoisted_35 = { class: "text-xs tracking-wide" }
const _hoisted_36 = {
  key: 1,
  class: "flex flex-row items-center py-2"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "block text-base font-bold"
}
const _hoisted_40 = { class: "text-xs opacity-30" }
const _hoisted_41 = { class: "text-xs tracking-wide truncate w-10/12" }
const _hoisted_42 = {
  key: 3,
  class: "flex flex-row items-center py-2"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 4,
  class: "block text-base font-bold"
}
const _hoisted_46 = {
  key: 5,
  class: "block text-sm font-extralight w-full overflow-ellipsis text-justify"
}
const _hoisted_47 = {
  key: 6,
  class: "block text-base font-bold"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "block text-base font-bold" }, "Contact details", -1)
const _hoisted_49 = { class: "flex flex-row w-full space-x-5 items-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Address", -1)
const _hoisted_51 = { class: "text-sm font-extralight" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_53 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Phone", -1)
const _hoisted_55 = { class: "text-sm font-extralight" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_57 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Email", -1)
const _hoisted_59 = { class: "text-sm font-extralight" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_61 = {
  key: 2,
  class: "p-3"
}
const _hoisted_62 = {
  key: 3,
  class: "p-3"
}
const _hoisted_63 = {
  key: 4,
  class: "p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuShare = _resolveComponent("MenuShare")!
  const _component_MenuEditUser = _resolveComponent("MenuEditUser")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_DropDownStage = _resolveComponent("DropDownStage")!
  const _component_TimeLineSection = _resolveComponent("TimeLineSection")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_FilesSection = _resolveComponent("FilesSection")!
  const _component_EvaluationsAnswerForm = _resolveComponent("EvaluationsAnswerForm")!
  const _component_ChallengeTab = _resolveComponent("ChallengeTab")!
  const _component_WarningModal = _resolveComponent("WarningModal")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_AddCandidateInJob = _resolveComponent("AddCandidateInJob")!
  const _component_ModalRejectCandidate = _resolveComponent("ModalRejectCandidate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MenuShare, {
            candidateId: _ctx.userInfo.candidate.id
          }, null, 8, ["candidateId"])
        ]),
        (_ctx.path === '/job-candidates' || _ctx.$route.name === 'JobCandidateShow')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_MenuEditUser, {
                onOpenEdit: _ctx.openEdit,
                onCopy: _ctx.copyCandidate,
                onDelete: _ctx.deleteCandidate,
                candidateId: _ctx.candidateId,
                jobCandidateId: _ctx.userInfo.candidate.candidate_id,
                stageId: _ctx.stageId,
                onRejectCandidate: _ctx.rejectCandidate
              }, null, 8, ["onOpenEdit", "onCopy", "onDelete", "candidateId", "jobCandidateId", "stageId", "onRejectCandidate"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowRejected(true))),
            class: "flex lg:truncate bg-gray-100 text-pink-400 text-sm py-2 px-4 cursor-pointer rounded-full border-2 border-white hover:border-pink-200 hover:bg-pink-100 hover:text-pink-500"
          }, _hoisted_8)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (
            _ctx.renderDropDown(_ctx.userInfo?.current_stage) &&
            _ctx.$route.name === 'JobCandidateShow' &&
            !_ctx.isLoading
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "px-2 border-r-2 border-white",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.validateLastStage(
                  _ctx.userInfo.next_stage?.job_stage?.stage?.name,
                  _ctx.userInfo.next_stage?.id
                )
              ))
                  }, _toDisplayString(_ctx.userInfo.next_stage?.job_stage?.stage?.name), 1),
                  _createVNode(_component_DropDownStage, {
                    stages: _ctx.userInfo?.job_candidate_stages,
                    onReloadCandidates: _ctx.reloadCandidates,
                    onSetLoadingStage: _ctx.setLoadingStage
                  }, null, 8, ["stages", "onReloadCandidates", "onSetLoadingStage"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (
          _ctx.userInfo?.current_stage === 'Hiring' &&
          _ctx.$route.name === 'JobCandidateShow'
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.getInitials(
              `${_ctx.userInfo.candidate.first_name} ${_ctx.userInfo.candidate.last_name}`
            )), 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(`${_ctx.userInfo.candidate.first_name} ${_ctx.userInfo.candidate.last_name}`), 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.userInfo.candidate.position), 1),
            (
              _ctx.userInfo &&
              _ctx.userInfo.candidate &&
              _ctx.userInfo.candidate.salary_expectation !== null
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.buildConvertions(
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.expected_salary_convertion?.MXN / 12
                  : _ctx.userInfo?.candidate?.expected_salary_convertion?.MXN || '0',
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.expected_salary_convertion?.USD / 12
                  : _ctx.userInfo?.candidate?.expected_salary_convertion?.USD || '0'
              )) + " " + _toDisplayString(_ctx.userInfo?.candidate?.show_monthly_salaries ? 'Monthly' : 'Annual'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, " Salary expectation: - ")),
            (
              _ctx.userInfo &&
              _ctx.userInfo.candidate &&
              _ctx.userInfo.candidate.current_salary !== null
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.buildConvertionsCurrent(
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.current_salary_convertion?.MXN / 12
                  : _ctx.userInfo?.candidate?.current_salary_convertion?.MXN || '0',
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.current_salary_convertion?.USD / 12
                  : _ctx.userInfo?.candidate?.current_salary_convertion?.USD || '0'
              )) + " " + _toDisplayString(_ctx.userInfo?.candidate?.show_monthly_salaries ? 'Monthly' : 'Annual'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, " Current salary: - "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("ul", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("li", {
                class: _normalizeClass(["cursor-pointer py-1 px-4 rounded transition text-black font-bold", _ctx.activeTab !== _ctx.tabs[index] && ' text-black opacity-30']),
                onClick: ($event: any) => (_ctx.changeCandidateTab(index))
              }, _toDisplayString(tab), 11, _hoisted_27)
            ]))
          }), 128))
        ]),
        _hoisted_28
      ]),
      (_ctx.activeTab === `Timeline`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_TimeLineSection, {
              onOpenEdit: _ctx.openEdit,
              userEmail: _ctx.userInfo.candidate.email
            }, null, 8, ["onOpenEdit", "userEmail"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Profile`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_work_histories &&
            _ctx.userInfo.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, " Work experience "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo.candidate.candidate_work_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-2"
                }, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(`${new Date(item.start_date).getFullYear()} - ${_ctx.buildNow(
              new Date(item.end_date).getFullYear(),
              item.is_current
            )}`), 1),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(`${item.job_title} at ${
                item.company_name ? item.company_name : ' Not specified'
              }`), 1)
                ]))
              }), 128)),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_work_histories &&
            _ctx.userInfo.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                : _createCommentVNode("", true),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_education_histories &&
            _ctx.userInfo.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Education "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo.candidate
            .candidate_education_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-2 w-full"
                }, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(`${new Date(item.start_date).getFullYear()} - ${_ctx.buildNow(
              new Date(item.end_date).getFullYear(),
              item.is_current
            )}`), 1),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(`${item.degree} at ${item.learning_center}`), 1)
                ]))
              }), 128)),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_education_histories &&
            _ctx.userInfo.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, " Summary "))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.userInfo.candidate.summary), 1))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.skills.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Skills "))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.skills.length > 0)
                ? (_openBlock(), _createBlock(_component_Chips, {
                    key: 7,
                    chips: _ctx.userInfo.candidate.skills,
                    isInput: false
                  }, null, 8, ["chips"]))
                : _createCommentVNode("", true),
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.userInfo.candidate.candidate_location
              ? _ctx.userInfo.candidate.candidate_location.location.street_address
              : 'No address'), 1)
              ]),
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.userInfo.candidate.phone), 1)
              ]),
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.userInfo.candidate.email), 1)
              ]),
              _hoisted_60
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Files`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createVNode(_component_FilesSection)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Talent evaluation`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createVNode(_component_EvaluationsAnswerForm)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Challenge`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createVNode(_component_ChallengeTab, {
              candidateId: _ctx.userInfo?.id,
              onReloadOne: _ctx.reloadOne,
              status: _ctx.userInfo?.job_candidate_challenge?.challenge_status,
              isSent: _ctx.userInfo?.challenge_sent,
              data: _ctx.userInfo?.job_candidate_challenge,
              resend: _ctx.userInfo?.can_resend_challenge
            }, null, 8, ["candidateId", "onReloadOne", "status", "isSent", "data", "resend"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowModal(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_WarningModal, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowModal(false))),
          onEmitAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeCurrentStage(_ctx.userInfo.next_stage?.id))),
          message: "Are you sure you want to hire the candidate?"
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalCopy,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalCopy = false)),
      size: "lg:w-1/2 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidateInJob, {
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModalCopy = false)),
          onReloadCandidate: _ctx.reloadOne,
          candidateId: _ctx.userInfo.candidate.candidate_id,
          modalTitle: `Copy this canddidate to other job`
        }, null, 8, ["onReloadCandidate", "candidateId"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ModalRejectCandidate, {
      showModal: _ctx.showRejected,
      onCloseModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setShowRejected(false))),
      candidateId: _ctx.userInfo.candidate.candidate_id,
      stageId: _ctx.stageId,
      onReloadCandidates: _ctx.reloadCandidates
    }, null, 8, ["showModal", "candidateId", "stageId", "onReloadCandidates"])
  ], 64))
}